import { takeLatest, put, call, select } from 'redux-saga/effects';
import { UPDATE_CHILD_SAGA } from "../sagaTypes";
import { loaderAction, setChildFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { CHILD_FORM_INITIAL } from "../initialStateConstant";
import { getChildrenSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/update_child`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerUpdateChild(args) {
    const user = yield select(state => state.user);
    const currentUser = yield select(state => state.currentUser);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('child_id', args.data.child_id);
        formData.append('name', args.data.name);
        formData.append('birthday', args.data.birthday);
        formData.append('parent', currentUser.id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму редактирования ребёнка
            yield put(setChildFormAction(CHILD_FORM_INITIAL));
            // Запрашиваем новые данные
            yield put(getChildrenSagaAction({ id: currentUser.id }));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherUpdateChild() {
    yield takeLatest(UPDATE_CHILD_SAGA, workerUpdateChild);
}